import type { ResponseText } from '@mentimeter/http-clients';
import type { OpenEndedResponse } from '../types';

function isOpenEndedResultUi(obj: any): obj is OpenEndedResponse {
  return 'participantDisplayName' in obj;
}

function getVoteCount(result: OpenEndedResponse | ResponseText): number {
  return isOpenEndedResultUi(result) ? result.voteCount : result.upvotes;
}

export function getVotingOnAnswersSplitResults<
  T extends OpenEndedResponse | ResponseText,
>(
  results: T[],
): {
  resultsWithVotes: T[];
  resultsWithoutVotes: T[];
  indexOfFirstResultWithoutVotes: number;
} {
  const sortedResults = results.sort(
    (a, b) => getVoteCount(b) - getVoteCount(a),
  );
  const indexOfFirstResultWithoutVotes = sortedResults.findIndex(
    (item) => getVoteCount(item) <= 0,
  );
  const resultsWithVotes =
    indexOfFirstResultWithoutVotes === -1
      ? sortedResults
      : sortedResults.slice(0, indexOfFirstResultWithoutVotes);
  const resultsWithoutVotes =
    indexOfFirstResultWithoutVotes === -1
      ? []
      : sortedResults.slice(indexOfFirstResultWithoutVotes);

  return {
    resultsWithVotes,
    resultsWithoutVotes,
    indexOfFirstResultWithoutVotes,
  };
}
